import { api } from './index';
import { Methods } from './interfaces';

const getDialog = () => {
  return api<void, any[]>({
    method: Methods.GET,
    route: '/chatgpt',
  });
};

const getCompletion = (prompt: string, gptVersion: 3 | 4) => {
  return api<{ prompt: string; gptVersion: number }, { text: string }>({
    method: Methods.POST,
    route: '/chatgpt',
    payload: { prompt, gptVersion },
  });
};

export const chatGPTApi = { getDialog, getCompletion };
